import { render, staticRenderFns } from "./VirtualPosReceiptDialog.vue?vue&type=template&id=31ce1813"
import script from "./VirtualPosReceiptDialog.vue?vue&type=script&lang=js"
export * from "./VirtualPosReceiptDialog.vue?vue&type=script&lang=js"
import style0 from "./VirtualPosReceiptDialog.vue?vue&type=style&index=0&id=31ce1813&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports